import { defineComponent as _defineComponent } from 'vue'
import type { ReelTitles } from '@/components/experiments/ReelsExp/components/query';

import ReelControlSidebar from '@/components/experiments/ReelsExp/components/ReelControlSidebar.vue';
import ReelControlOverlay from '@/components/experiments/ReelsExp/components/ReelControlOverlay.vue';
import VerticalRuler from '@/components/experiments/ReelsExp/components/VerticalRuler.vue';
import HLSPlayer from '@/components/experiments/ReelsExp/components/HLSPlayer.vue';
import BasicButton from '@/ui-components/BasicButton.vue';

import { TitleListType } from '@/@types/graphql-types';
import { isTitleInList } from '@/helpers/title-helper';
import { useListActions } from '@/helpers/composables/useListActions';
import { getClipFromMovieOrShow } from '@/components/experiments/ReelsExp/components/query';

import ReelsExp from '../index';

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelView',
  props: {
    titles: null,
    selectedIndex: { default: 0 }
  },
  emits: ["close", "next", "prev"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void;
	(e: 'next', currentIndex: number): void;
	(e: 'prev', currentIndex: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { titles: ReelTitles[], selectedIndex: number };





const scrollContainer = ref<HTMLElement | null>(null);
const hlsPlayer = ref<typeof HLSPlayer | null>(null);

const currentIndex = ref(Math.max(0, props.selectedIndex));
const selectedTitle = computed(() => props.titles[currentIndex.value]?.node);

// HANDLE TOUCH
const touchStartY = ref(0);
const touchEndY = ref(0);
const touchStartX = ref(0);
const touchStartTime = ref(0);
const minSwipeDistance = 50;
const maxSwipeTime = 300;
const hasMoved = ref(false);
const isSwiping = ref(false);

function handleTouchStart(event: TouchEvent) {
	touchStartY.value = event.touches[0].clientY;
	touchStartX.value = event.touches[0].clientX;
	touchStartTime.value = Date.now();
	hasMoved.value = false;
	isSwiping.value = true;
}

function handleTouchMove(event: TouchEvent) {
	if (!isSwiping.value) return;

	const currentY = event.touches[0].clientY;
	const currentX = event.touches[0].clientX;

	const deltaY = Math.abs(currentY - touchStartY.value);
	const deltaX = Math.abs(currentX - touchStartX.value);

	if (deltaY > 5 || deltaX > 5) {
		hasMoved.value = true;
	}

	if (deltaY > deltaX) {
		event.preventDefault();
		touchEndY.value = currentY;
	}
}

function handleTouchEnd() {
	if (!isSwiping.value) return;

	const touchDuration = Date.now() - touchStartTime.value;
	const swipeDistance = touchEndY.value - touchStartY.value;

	if (hasMoved.value && Math.abs(swipeDistance) >= minSwipeDistance && touchDuration <= maxSwipeTime) {
		if (swipeDistance > 0) scrollUp();
		else scrollDown();
	}

	isSwiping.value = false;
	hasMoved.value = false;
}

// HANDLE WHEEL
const wheelThrottleTimeout = ref<number | null>(null);
const wheelThrottleDelay = 1500;

function handleWheel(event: WheelEvent) {
	event.preventDefault();
	if (wheelThrottleTimeout.value !== null) return;

	if (event.deltaY > 0) scrollDown();
	else scrollUp();

	wheelThrottleTimeout.value = window.setTimeout(() => {
		wheelThrottleTimeout.value = null;
	}, wheelThrottleDelay);
}

function scrollUp() {
	ReelsExp.trackEvent({ action: 'click', label: 'previous_video', property: 'shorts_popular' });
	if (currentIndex.value > 0) {
		currentIndex.value--;
	}

	emit('prev', currentIndex.value);
}

function scrollDown() {
	ReelsExp.trackEvent({ action: 'click', label: 'next_video', property: 'shorts_popular' });
	if (currentIndex.value < props.titles.length - 1) {
		currentIndex.value++;

		emit('next', currentIndex.value);
	}
}

// LIST ACTIONS
const { setInDislikelist, setInLikelist, setInSeenlist, setInWatchlist } = useListActions();

async function action(action: string, title: any) {
	const payload = {
		objectType: title.objectType,
		objectId: title.objectId,
		title: title.content.title,
	};

	switch (action) {
		case 'seen':
			await setInSeenlist(title.id, isTitleInList(TitleListType.CaughtUp, title), payload);
			break;
		case 'bookmark':
			await setInWatchlist(title.id, isTitleInList(TitleListType.WatchNext, title), payload);
			break;
		case 'like':
			await setInLikelist(
				title.id,
				isTitleInList(TitleListType.Likelist, title),
				isTitleInList(TitleListType.Dislikelist, title),
				payload
			);
			break;
		case 'dislike':
			await setInDislikelist(
				title.id,
				isTitleInList(TitleListType.Dislikelist, title),
				isTitleInList(TitleListType.Likelist, title),
				payload
			);
			break;
	}
}

return { __sfc: true,props, emit, scrollContainer, hlsPlayer, currentIndex, selectedTitle, touchStartY, touchEndY, touchStartX, touchStartTime, minSwipeDistance, maxSwipeTime, hasMoved, isSwiping, handleTouchStart, handleTouchMove, handleTouchEnd, wheelThrottleTimeout, wheelThrottleDelay, handleWheel, scrollUp, scrollDown, setInDislikelist, setInLikelist, setInSeenlist, setInWatchlist, action, ReelControlSidebar, ReelControlOverlay, VerticalRuler, HLSPlayer, BasicButton, getClipFromMovieOrShow }
}

})